import {
  Box,
  Drawer,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React, { useEffect } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import useCustomStyles from '../../../../utils/hooks/CustomStylesHook'
import Prorithm from './Prorithm'
import SmartRing from './SmartRing'
import CloseIcon from '@mui/icons-material/Close'
import {
  DEVICE_VITAL_COMPONENTS,
  ERROR_DEVICES_SCREEN,
  VISIT_STATUS_FINISHED,
} from './Constant'
import SleepTracking from './detailScreens/SleepTracking'
import Spo2Tracking from './detailScreens/Spo2Tracking'
import VitalRange from './VitalRange'
import Overview from './Overview'
import HeartRateTracking from './detailScreens/HeartRateTracking'
import StressTracking from './detailScreens/StressTracking'
import { useWebSocket } from './Socket'
import { getVitalRanges } from '../../../../services/DeviceServices'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import {
  setProrithm,
  setProrithmEcg,
  updateProrithm,
  updateProrithmEcg,
  updateSafeRanges,
} from './DeviceSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { selectPatientData } from '../../OpdPatientSlice'
import HeartRateVarTracking from './detailScreens/HeartRateVarTracking'
import SkinTemperatureTracking from './detailScreens/SkinTemperatureTracking'
import { toast } from 'react-toastify'
import BloodGlucoseTracking from './detailScreens/BloodGlucoseTracking'
import BloodPressureTracking from './detailScreens/BloodPressureTracking'
// import { useWebSocket } from './Socket'

const styles = () => ({
  deviceTab: {
    textTransform: 'capitalize',
  },
  drawerHeading: {
    background: '#183f7c',
    color: '#ffffff',
    position: 'sticky',
    top: 0,
  },
  nextBtn: {
    background: '#4682b4',
    textTransform: 'capitalize',
  },
})

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const Devices = () => {
  const { id }: any = useParams()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const useMuiResponsiveWidth = () => {
    const theme = useTheme()

    const isXs = useMediaQuery(theme.breakpoints.only('xs'))
    const isSm = useMediaQuery(theme.breakpoints.only('sm'))
    const isMd = useMediaQuery(theme.breakpoints.only('md'))
    const isLg = useMediaQuery(theme.breakpoints.only('lg'))
    const isXl = useMediaQuery(theme.breakpoints.only('xl'))

    if (isXs) return '95%'
    if (isSm) return '85%'
    if (isMd) return '50%'
    if (isLg) return '50%'
    if (isXl) return '40%'

    return '50%'
  }

  const patient = useAppSelector(selectPatientData)

  const [value, setValue] = React.useState(0)
  const [openDrawer, setOpenDrawer] = React.useState(false)
  const [selectedVital, setSelectedVital] = React.useState('')

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const handleDrawerClose = () => {
    setOpenDrawer(false)
    setSelectedVital('')
  }

  const RenderVitalDetails = (selectedVital: string) => {
    switch (selectedVital) {
      case DEVICE_VITAL_COMPONENTS?.SLEEP:
        return <SleepTracking />
      case DEVICE_VITAL_COMPONENTS?.SPO2:
        return <Spo2Tracking />
      case DEVICE_VITAL_COMPONENTS?.HEART_RATE:
        return <HeartRateTracking />
      case DEVICE_VITAL_COMPONENTS?.STRESS:
        return <StressTracking />
      case DEVICE_VITAL_COMPONENTS?.HEART_RATE_VAR:
        return <HeartRateVarTracking />
      case DEVICE_VITAL_COMPONENTS?.SKIN_TEMPERATURE:
        return <SkinTemperatureTracking />
      case DEVICE_VITAL_COMPONENTS?.BLOOD_GLUCOSE:
        return <BloodGlucoseTracking />
      case DEVICE_VITAL_COMPONENTS?.BLOOD_PRESSURE_SYSTOLIC:
        return <BloodPressureTracking selectedVital={selectedVital} />
      case DEVICE_VITAL_COMPONENTS?.BLOOD_PRESSURE_DIASTOLIC:
        return <BloodPressureTracking selectedVital={selectedVital} />
      default:
        return <div>NA</div>
    }
  }

  const handleGetSafeRanges = async () => {
    const response = await getVitalRanges(id)
    if (response?.success) {
      dispatch(
        updateSafeRanges({
          heartRate: {
            min: Number(response?.data?.heartRateMin),
            max: Number(response?.data?.heartRateMax),
          },
          spo2: {
            min: Number(response?.data?.spo2Min),
            max: Number(response?.data?.spo2Max),
          },
          bloodPressureSystolic: {
            min: Number(response?.data?.bloodPressureSystolicMin),
            max: Number(response?.data?.bloodPressureSystolicMax),
          },
          bloodPressureDiastolic: {
            min: Number(response?.data?.bloodPressureDiastolicMin),
            max: Number(response?.data?.bloodPressureDiastolicMax),
          },
          skinTemperature: {
            min: Number(response?.data?.skinTemperatureMin),
            max: Number(response?.data?.skinTemperatureMax),
          },
          respiratoryRate: {
            min: Number(response?.data?.respiratoryRateMin),
            max: Number(response?.data?.respiratoryRateMax),
          },
          heartRateVar: {
            min: Number(response?.data?.heartRateVarMin),
            max: Number(response?.data?.heartRateVarMax),
          },
          stress: {
            min: Number(response?.data?.stressMin),
            max: Number(response?.data?.stressMax),
          },
          sleep: {
            min: Number(response?.data?.sleepMin),
            max: Number(response?.data?.sleepMax),
          },
          bloodGlucose: {
            min: Number(response?.data?.bloodGlucoseMin),
            max: Number(response?.data?.bloodGlucoseMax),
          },
        })
      )
    }
  }

  // function generateUnique12DigitNumber() {
  //   const timestamp = Date.now().toString().slice(-8)
  //   const randomNum = Math.floor(1000 + Math.random() * 9000)
  //   return `${timestamp}${randomNum}`
  // }

  function generateUnique4DigitNumber() {
    return Date.now().toString().slice(-4)
  }

  // const lastFourDigits = selectedDevice?.split(':')?.slice(-2)?.join(':')

  const { createSocketConnection, closeSocketConnection } = useWebSocket(
    `${process.env.REACT_APP_PRORITHM_SOCKET_URL}?patientId=prorythm_${
      patient?.muhId
    }&deviceId=patient_${generateUnique4DigitNumber()}`,
    (message: any) => {
      if (message?.ecg_clean) {
        dispatch(
          updateProrithmEcg(
            message?.ecg_clean?.map(({ e, t }: any) => ({
              t, // Time value
              e, // ECG value
            }))
          )
        )
      }
      if (message?.vitals) {
        dispatch(
          updateProrithm({
            ...message?.vitals,
            hrv: [
              {
                v: Number((message?.vitals?.hrv?.[0]?.v / 10).toFixed(2)),
                t: message?.vitals?.hrv?.[0]?.t,
              },
            ],
          })
        )
      }
    }
  )

  // Establish WebSocket connection
  useEffect(() => {
    if (patient?.muhId) {
      handleGetSafeRanges()
      createSocketConnection()
    } else {
      toast(ERROR_DEVICES_SCREEN, {
        position: 'top-right',
        hideProgressBar: true,
        closeButton: false,
        theme: 'dark',
        autoClose: 4000,
      })
      navigate('/opd')
    }
    // const intervalId = setInterval(() => {
    //   sendData({ message: 'test' })
    // }, 50000)

    return () => {
      // clearInterval(intervalId)
      closeSocketConnection()
      dispatch(setProrithm({}))
      dispatch(setProrithmEcg([]))
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Box width={'97%'} height={'100%'} pl={2} pt={2}>
      <Drawer
        anchor='right'
        open={openDrawer}
        onClose={handleDrawerClose}
        PaperProps={{
          style: {
            width: useMuiResponsiveWidth(),
          },
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            pl={1}
            pr={1}
            className={classes?.drawerHeading}
          >
            <Typography fontSize={'17px'} fontWeight={600}>
              {selectedVital}
            </Typography>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon htmlColor='#ffffff' />
            </IconButton>
          </Grid>
          <Grid item xs={12} flex={1}>
            {RenderVitalDetails(selectedVital)}
          </Grid>
        </Grid>
      </Drawer>
      {patient?.visitStatus !== VISIT_STATUS_FINISHED ? (
        <>
          <Box borderBottom={1} borderColor='divider'>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label='basic tabs example'
            >
              <Tab
                label='Overview'
                {...a11yProps(0)}
                className={classes?.deviceTab}
              />
              <Tab
                label='Set Vital Range'
                {...a11yProps(1)}
                className={classes?.deviceTab}
              />
              <Tab
                label='Prorithm'
                {...a11yProps(2)}
                className={classes?.deviceTab}
              />
              <Tab
                label='Smart Ring'
                {...a11yProps(3)}
                className={classes?.deviceTab}
              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Overview />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <VitalRange />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Prorithm
              setOpenDrawer={setOpenDrawer}
              setSelectedVital={setSelectedVital}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <SmartRing
              setOpenDrawer={setOpenDrawer}
              setSelectedVital={setSelectedVital}
            />
          </CustomTabPanel>
        </>
      ) : (
        <Typography>
          Devices data cannot be viewed for completed visit
        </Typography>
      )}
    </Box>
  )
}

// const DeviceSelection = () => {
//   const theme = useTheme()
//   const classes = useCustomStyles(styles, theme)

//   const [devices, setDevices] = useState([])
//   const [selectedDevice, setSelectedDevice] = useState('')
//   const [isDeviceSelected, setIsDeviceSelected] = useState(false)

//   const handleNext = () => {
//     setIsDeviceSelected(true)
//   }

//   const getAllDevices = async () => {
//     const response = await getDevices()
//     if (response?.success) {
//       setDevices(response?.data?.data)
//     } else {
//       setDevices([])
//     }
//   }

//   useEffect(() => {
//     getAllDevices()

//     return () => {
//       setIsDeviceSelected(false)
//       setSelectedDevice('')
//     }
//   }, [])

//   return (
//     <Box width={'97%'} height={'100%'} pl={2} pt={2}>
//       {selectedDevice && isDeviceSelected ? (
//         <Devices selectedDevice={selectedDevice} />
//       ) : (
//         <Box
//           display={'flex'}
//           flexDirection={'column'}
//           justifyContent={'start'}
//           alignItems={'center'}
//           gap={5}
//           height={'100%'}
//         >
//           <Typography fontSize={'25px'} fontWeight={500}>
//             Select Device
//           </Typography>
//           <Autocomplete
//             size='small'
//             disablePortal
//             options={devices}
//             inputValue={selectedDevice}
//             sx={{ width: 300 }}
//             getOptionLabel={(option: any) => option?.prorithmDeviceId}
//             renderInput={(params) => <TextField {...params} label='Device' />}
//             onInputChange={(event, newInputValue: any) => {
//               setSelectedDevice(newInputValue)
//             }}
//           />
//           <Button
//             variant='contained'
//             size='small'
//             className={classes?.nextBtn}
//             onClick={handleNext}
//           >
//             Next
//           </Button>
//         </Box>
//       )}
//     </Box>
//   )
// }

export default Devices
